import extractTextFromRichEditorValue from 'components/helpers/extractTextFromRichEditorValue';
import {RICH_EDITOR_VALUE} from 'components/controls/RichEditor/NewRichEditor';

export default function normalizeFormToStringValues(values) {
    const extractedData = {};
    Object.entries(values).forEach(([key, value]) => extractedData[key] = !value || !value[RICH_EDITOR_VALUE]
        ? value
        : extractTextFromRichEditorValue(value));
    return extractedData;
}



// WEBPACK FOOTER //
// ./src/components/helpers/normalizeFormToStringValues.js